import type { DiscoveryGetTrends200PageAllOfThreeContentItemBasicInfoAllOfTwoCategory } from './discoveryGetTrends200PageAllOfThreeContentItemBasicInfoAllOfTwoCategory';

/**
 * 트렌드 기본 정보
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemBasicInfoAllOfTwo = {
  category?: DiscoveryGetTrends200PageAllOfThreeContentItemBasicInfoAllOfTwoCategory;
  name: string;
};
